import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DirectToLenderAppSummary from "../direct-to-lender-app-summary";
import DownloadMppModal from "./download-mpp-modal";
import ResponseInformation from "./response-information";
import ResponseDetails from "./response-details";
import { mapState, mapActions, mapGetters } from "vuex";
import { LOAD_SUBMISSION_HISTORY, LOAD_MPP_DATA, TOGGLE_DEAL_ACCEPTED_STATUS, PREVIEW_LENDER_RESPONSE, PRINT_DOCUMENT_FORM, DOWNLOAD_MPP_DOCUMENT, PREVIEW_MPP_DOCUMENT, GENERATE_MPP } from "../../../../store/lender-submit-actions";
import { DOWNLOAD_DOCUMENT } from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import { lowerCase } from "lodash";
import IncidentMessage from "@Broker/@Modules/status-page/components/incident-message.vue";
import LenderInformationSection from "@Broker/@Modules/clients/applications/application/components/pages-components/direct-to-lender/lender-response/lender-information-section.vue";
import ManualResponseModal from "@Broker/@Modules/clients/applications/application/components/pages-components/direct-to-lender/lender-submit/manual-response-modal.vue";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS } from "@Broker/@Modules/main/store/account/account-getters";
import { LOAD_PERSONAL_DETAILS } from "@Broker/@Modules/main/store/account/account-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LenderResponse",
  components: {
    DirectToLenderAppSummary,
    ResponseInformation,
    ResponseDetails,
    DownloadMppModal,
    IncidentMessage,
    LenderInformationSection,
    ManualResponseModal
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      mppDisabled: false,
      showingResponseDetails: false,
      currentResponse: {},
      focusedSection: null,
      currentMpp: {},
      selectedMpps: [],
      currentMppDocDownloading: {},
      downloadingMppDocuments: {
        status: true,
        loading: false
      },
      previewingMpp: false,
      generatingMpp: false,
      showingLenderInformation: false,
      selectedSubmissionId: null,
      selectedDecision: null,
      currentManualApplicationData: {},
      manualResponseDecision: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationStore", ["submissionHistory", "mpp"])), mapGetters("ApplicationStore", ["lenderResponses"])), mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS])), {}, {
    accessRights() {
      return this.CURRENT_ACCOUNT_ACCESS_RIGHTS;
    },
    sectionTitle() {
      return this.$t(this.showingLenderInformation ? "direct-to-lender.lenderSubmit.lenderInformation" : "direct-to-lender.lenderResponse.responseInformation");
    }
  }),
  async mounted() {
    this.LOAD_SUBMISSION_HISTORY({
      clientUsername: this.clientUsername,
      applicationId: this.applicationId
    });
    this.LOAD_MPP_DATA({
      clientUsername: this.clientUsername,
      applicationId: this.applicationId
    });
    await this.LOAD_PERSONAL_DETAILS();
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_SUBMISSION_HISTORY, LOAD_MPP_DATA, TOGGLE_DEAL_ACCEPTED_STATUS, PREVIEW_LENDER_RESPONSE, PRINT_DOCUMENT_FORM, DOWNLOAD_MPP_DOCUMENT, PREVIEW_MPP_DOCUMENT, GENERATE_MPP])), mapActions("DocumentsStore", [DOWNLOAD_DOCUMENT])), mapActions("AccountStore", [LOAD_PERSONAL_DETAILS])), {}, {
    handleResponseDetails({
      data,
      focusSection
    }) {
      if (focusSection) this.focusedSection = "#responseNotes";
      this.currentResponse = this.submissionHistory.byId[data.submissionId];
      this.showingResponseDetails = true;
    },
    handleLenderInformationCancel() {
      this.showingLenderInformation = false;
    },
    handleLenderInformationProceed({
      submissionId,
      decision
    }) {
      const submission = this.submissionHistory.byId[submissionId];
      this.currentManualApplicationData = submission;
      this.manualResponseDecision = decision;
      this.showingLenderInformation = false;
      this.$refs.manualResponseModal.show();
    },
    async reloadAfterManualResponse() {
      await this.LOAD_SUBMISSION_HISTORY({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      await this.LOAD_MPP_DATA({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
    },
    async handleResponseAccept({
      data,
      index
    }) {
      const {
        clientUsername,
        applicationId,
        agentUsername
      } = this;
      try {
        await this.TOGGLE_DEAL_ACCEPTED_STATUS({
          clientUsername,
          applicationId,
          agentUsername,
          submissionId: data.submissionId
        });
        this.$refs.responseInformation.stopLoader({
          type: "accept",
          index
        });
      } catch (e) {
        this.$refs.responseInformation.stopLoader({
          type: "accept",
          index
        });
      }
    },
    async handleResponsePreview({
      data,
      index
    }) {
      const lenderCommitmentDocumentS3Key = data.lenderCommitmentDocumentS3Key;
      const submissionId = data.submissionId;
      const mortgageType = lowerCase(data.mortgageType);
      const {
        clientUsername,
        applicationId
      } = this;
      try {
        if (lenderCommitmentDocumentS3Key) {
          await this.PREVIEW_LENDER_RESPONSE({
            lenderCommitmentDocumentS3Key,
            clientUsername,
            applicationId
          });
        } else {
          const forms = [{
            type: "mortgageCommitment",
            province: "FEDERAL",
            mortgage: mortgageType
          }];
          const payload = {
            clientUsername: this.clientUsername,
            applicationId: this.applicationId,
            submissionId,
            forms
          };
          await this.PRINT_DOCUMENT_FORM(payload);
        }
        this.$refs.responseInformation.stopLoader({
          type: "preview",
          index,
          status: true
        });
      } catch (e) {
        this.$refs.responseInformation.stopLoader({
          type: "preview",
          index,
          status: false
        });
      }
    },
    handleBack() {
      this.focusedSection = null;
      this.showingResponseDetails = false;
    },
    handleResponseDownloadMpp({
      data
    }) {
      this.$refs.downloadMppModal.show();
      const {
        submissionId
      } = data;
      this.currentMpp = this.mpp.byId[submissionId];
    },
    handleSelectMpp(document) {
      const {
        fileName: currentFileName
      } = document;
      const alreadySelected = this.selectedMpps.some(mpp => {
        var _context;
        return _includesInstanceProperty(_context = mpp.fileName).call(_context, currentFileName);
      });
      if (alreadySelected) {
        var _context2;
        this.selectedMpps = _filterInstanceProperty(_context2 = this.selectedMpps).call(_context2, mpp => {
          var _context3;
          return !_includesInstanceProperty(_context3 = mpp.fileName).call(_context3, currentFileName);
        });
      } else {
        this.selectedMpps.push(document);
      }
    },
    async handleDownloadMpp() {
      try {
        this.downloadingMppDocuments.loading = true;
        const {
          applicationId,
          clientUsername
        } = this;
        for (const file of this.selectedMpps) {
          const {
            s3Key,
            fileName
          } = file;
          this.currentMppDocDownloading = {
            s3Key,
            loading: true
          };
          await this.DOWNLOAD_MPP_DOCUMENT({
            fileName,
            s3Key,
            applicationId,
            clientUsername
          });
        }
        this.currentMppDocDownloading = {};
        this.selectedMpps = [];
      } catch (e) {
        this.downloadingMppDocuments.status = false;
      } finally {
        this.downloadingMppDocuments.loading = false;
      }
    },
    async handlePreviewMpp({
      fileName,
      s3Key
    }) {
      const {
        applicationId,
        clientUsername
      } = this;
      this.previewingMpp = true;
      const {
        url
      } = await this.DOWNLOAD_DOCUMENT({
        clientUsername,
        applicationId,
        fileName,
        documentId: s3Key,
        download: false
      });
      this.PREVIEW_MPP_DOCUMENT(url);
      this.previewingMpp = false;
    },
    async handleResponseGenerateMpp({
      data
    }) {
      const {
        submissionId,
        mortgageType
      } = data;
      this.generatingMpp = true;
      await this.GENERATE_MPP({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        mortgageType: lowerCase(mortgageType),
        submissionId,
        quote: false
      });
      this.generatingMpp = false;
    },
    handleIncidentUpdate(hasIncident) {
      this.mppDisabled = hasIncident;
    }
  })
});